module.exports = __webpack_public_path__ + "img/Snipaste_2023-07-21_18-00-33.ec6d43ad.png";